import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function European() {
  return (
    <ApiCommunityDirectoryPage
      community="European"
      eyebrow="European community guide"
      title="European favorites, businesses, and local essentials in San Antonio."
      
      tags={["European community", "San Antonio", "Local businesses"]}
      claimText="Want your business featured in the European community guide?"
      modalIdPrefix="european-directory"
    />
  );
}
